module.exports = __webpack_public_path__ + "static/media/IMG_7578-min.22e52ffa.JPG";